import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg, fmtDate, PLAN_LABEL } from "../../api";
import { Input, Notice, PageHead, Select } from "../../components/ui";

interface Item { id: string; kind: "pf" | "pj"; name: string; plan: string; status: string; currency: string; createdAt: string; ownerEmail: string | null; userCount: number; lastLoginAt: string | null }

export function Clients() {
  const nav = useNavigate();
  const [search, setSearch] = useState("");
  const [kind, setKind] = useState("");
  const [plan, setPlan] = useState("");
  const [data, setData] = useState<{ total: number; items: Item[] } | null>(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    const t = setTimeout(() => {
      const q = new URLSearchParams();
      if (search) q.set("search", search);
      if (kind) q.set("kind", kind);
      if (plan) q.set("plan", plan);
      api<{ total: number; items: Item[] }>("GET", `/api/admin/tenants?${q}`).then((d) => { setData(d); setErr(""); }).catch((e) => setErr(errMsg(e)));
    }, 200);
    return () => clearTimeout(t);
  }, [search, kind, plan]);

  return (
    <>
      <PageHead title="Clientes" sub="Ambientes cadastrados. Dados financeiros dos clientes não são exibidos aqui." />
      <div className="toolbar">
        <Input placeholder="Buscar por nome ou e-mail" value={search} onChange={(e) => setSearch(e.target.value)} aria-label="Buscar" />
        <Select value={kind} onChange={(e) => setKind(e.target.value)} aria-label="Tipo">
          <option value="">Todos os tipos</option><option value="pf">Pessoa Física</option><option value="pj">Pessoa Jurídica</option>
        </Select>
        <Select value={plan} onChange={(e) => setPlan(e.target.value)} aria-label="Plano">
          <option value="">Todos os planos</option>
          {Object.entries(PLAN_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </Select>
      </div>
      {err && <Notice kind="error">{err}</Notice>}
      <div className="card" style={{ padding: 0, overflowX: "auto" }}>
        <table>
          <thead><tr><th>Cliente</th><th>Tipo</th><th>Plano</th><th>Moeda</th><th>Titular</th><th>Usuários</th><th>Último acesso</th><th>Criado em</th></tr></thead>
          <tbody>
            {data?.items.map((c) => (
              <tr key={c.id} className="click" onClick={() => nav(`/admin/clientes/${c.id}`)} tabIndex={0} onKeyDown={(e) => e.key === "Enter" && nav(`/admin/clientes/${c.id}`)}>
                <td>{c.name}</td><td>{c.kind.toUpperCase()}</td><td><span className="pill">{PLAN_LABEL[c.plan]}</span></td>
                <td className="tabular">{c.currency}</td><td>{c.ownerEmail ?? "—"}</td><td className="tabular">{c.userCount}</td>
                <td>{fmtDate(c.lastLoginAt)}</td><td>{fmtDate(c.createdAt)}</td>
              </tr>
            ))}
            {data && data.items.length === 0 && <tr><td colSpan={8} className="muted" style={{ textAlign: "center", padding: 32 }}>Nenhum cliente encontrado.</td></tr>}
          </tbody>
        </table>
      </div>
      {data && <p className="muted" style={{ fontSize: 12.5 }}>{data.total} ambiente(s)</p>}
    </>
  );
}
